<template>
  <div>
    <b-form-group>
      <b-table-simple
        bordered
        small
      >
        <b-thead head-variant="light">
          <b-tr>
            <b-th v-if="isEdit">
              {{ '' }}
            </b-th>
            <b-th
              v-if="letter.tableColumns['Код услуги']"
              class="text-center"
              style="width: 15%"
            >
              Код услуги
            </b-th>
            <b-th
              class="text-center w-75"
            >
              Наименование услуг
            </b-th>
            <b-th
              v-if="letter.tableColumns['Количество услуг']"
              style="width: 15%"
              class="text-center"
            >
              К-во услуг
            </b-th>
            <b-th
              v-if="letter.tableColumns['Стоимость за единицу']"
              class="text-center"
            >
              Стоимость
            </b-th>
            <b-th
              v-if="letter.tableColumns['Итоговая стоимость']"
              class="text-center"
            >
              Итоговая стоимость
            </b-th>
            <b-th
              v-if="isEdit"
              class="text-center"
            >
              {{ ' ' }}
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <template v-if="rowsLetter.length">
            <b-tr
              v-for="(r, i) in rowsLetter"
              :key="'B' + i"
            >
              <b-td v-if="isEdit">
                <div
                  class="d-flex"
                >
                  <div>
                    <b-button
                      id="newLine"
                      v-b-tooltip.hover
                      variant="outline"
                      class="addRowButton"
                      title="Новая строка"
                      @click="addTableRow(i + 1)"
                    >
                      <b-icon
                        class="poi"
                        icon="plus-circle"
                        font-scale="0.9"
                      />
                    </b-button>
                    <b-tooltip
                      triggers="hover"
                      target="newLine"
                    />
                  </div>
                  <div>
                    <b-button
                      id="newGroupLine"
                      v-b-tooltip.hover
                      variant="outline"
                      class="addRowButton"
                      title="Новая строка группы услуг"
                      @click="addNewRowOnlyLineGroup(i)"
                    >
                      <b-icon
                        icon="plus-circle"
                        font-scale="0.9"
                        variant="info"
                      />
                    </b-button>
                    <b-tooltip
                      triggers="hover"
                      target="newGroupLine"
                    />
                  </div>
                </div>
              </b-td>
              <template v-if="(typeof r !== 'string')">
                <b-td
                  v-if="r.code && letter.tableColumns['Код услуги']"
                >
                  <b-form-input
                    v-if="isEdit"
                    v-model="r.code.value"
                    class="text-center"
                  />
                  <div
                    v-else
                    class="text-center"
                  >
                    {{ r.code.value }}
                  </div>
                </b-td>
                <b-td
                  v-if="r.name"
                >
                  <b-form-textarea
                    v-if="isEdit"
                    v-model="r.name.value"
                    class="text-center"
                  />
                  <div
                    v-else
                    class="text-center"
                  >
                    {{ r.name.value }}
                  </div>
                </b-td>
                <b-td
                  v-if="r.count && letter.tableColumns['Количество услуг']"
                  class="text-center"
                >
                  <b-form-input
                    v-if="isEdit"
                    v-model="r.count.value"
                    :type="'number'"
                    class="text-center"
                    number
                    @input="letterRowDataInputHandler"
                  />
                  <div
                    v-else
                    class="text-center"
                  >
                    {{ r.count.value }}
                  </div>
                </b-td>
                <b-td
                  v-if="r.price && letter.tableColumns['Стоимость за единицу']"
                >
                  <b-form-input
                    v-model="r.price.value"
                    :type="'number'"
                    class="text-center"
                    number
                    @input="letterRowDataInputHandler"
                  />
                </b-td>
                <b-td
                  v-if="r.sum && letter.tableColumns['Итоговая стоимость']"
                  class="text-center"
                >
                  <span
                    style="font-size: 15px !important; font-weight: 500;"
                  >
                    {{ r.sum.value }}
                  </span>
                </b-td>
                <b-td v-if="isEdit">
                  <b-button
                    variant="outline"
                    @click="removeTableRow(i)"
                  >
                    <b-icon
                      icon="trash"
                      variant="danger"
                    />
                  </b-button>
                </b-td>
              </template>
              <template v-else>
                <b-td :colspan="colspanValue">
                  <b-form-textarea
                    v-if="isEdit"
                    id="textarea-rows"
                    v-model="rowsLetter[i]"
                    class="text-center"
                    placeholder="Введите наименование группы услуг"
                  />
                  <div
                    v-else
                    class="text-center"
                  >
                    {{ rowsLetter[i] }}
                  </div>
                </b-td>
                <b-td v-if="isEdit">
                  <b-button
                    variant="outline"
                    @click="removeTableRow(i)"
                  >
                    <b-icon
                      icon="trash"
                      variant="danger"
                    />
                  </b-button>
                </b-td>
              </template>
            </b-tr>
          </template>
        </b-tbody>
      </b-table-simple>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: 'IndemnityTemplateTable',
  props: {},
  data() {
    return {
      onlyNameRows: [
        {
          name: {
            value: '',
          },
        },
      ],
    };
  },
  computed: {
    letter() {
      return this.$store.state.Indemnity.letter;
    },
    isEdit() {
      return this.$store.state.Indemnity.isEditIndemnity;
    },
    rowsLetter() {
      if (this.letter.tableRows.length) {
        return this.letter.tableRows;
      }
      return [];
    },
    colspanValue() {
      const columns = this.letter.tableColumns;
      let value = 0;
      // eslint-disable-next-line no-restricted-syntax
      for (const key in columns) {
        if (columns[key]) value += 1;
      }
      return value;
    },
  },
  created() {},
  methods: {
    addNewRowOnlyLineGroup(index) {
      const row = '';
      const array = [...this.letter.tableRows.slice(0, index), row, ...this.letter.tableRows.slice(index, this.letter.tableRows.length)];
      this.$store.commit(this.$types.INDEMNITY_LETTER_SET, { ...this.letter, tableRows: array });
      this.$store.dispatch(this.$types.INDEMNITY_LETTER_NUMBERS_UPDATE);
    },
    addTableRow(index) {
      const row = {
        number: {
          // isVisible: this.letter.tableColumns['№'],
          isVisible: false,

          value: index,
        },
        code: {
          isVisible: this.letter.tableColumns['Код услуги'],
          value: '',
        },
        name: {
          isVisible: true,
          value: '',
        },
        count: {
          isVisible: this.letter.tableColumns['Количество услуг'],
          value: 1,
        },
        price: {
          isVisible: this.letter.tableColumns['Стоимость за единицу'],
          value: 0,
        },
        sum: {
          isVisible: this.letter.tableColumns['Итоговая стоимость'],
          value: 0,
        },
      };

      const array = [...this.letter.tableRows.slice(0, index), row, ...this.letter.tableRows.slice(index, this.letter.tableRows.length)];
      this.$store.commit(this.$types.INDEMNITY_LETTER_SET, { ...this.letter, tableRows: array });
      this.$store.dispatch(this.$types.INDEMNITY_LETTER_NUMBERS_UPDATE);
    },
    removeTableRow(index) {
      const array = [...this.letter.tableRows.slice(0, index), ...this.letter.tableRows.slice(index + 1, this.letter.tableRows.length)];
      const sumStringValue = array.reduce((sum, row) => (typeof row === 'string' ? +sum : +sum + +row.sum.value), 0);
      this.$store.commit(this.$types.INDEMNITY_LETTER_SET, { ...this.letter, tableRows: array, sumString: sumStringValue });
      this.$store.dispatch(this.$types.INDEMNITY_LETTER_NUMBERS_UPDATE);
    },
    letterRowDataInputHandler() {
      const array = this.letter.tableRows.map((row) => {
        const newRow = row;
        if (typeof row === 'string') return newRow;

        newRow.price.value = +newRow.price.value;
        newRow.count.value = +newRow.count.value;
        newRow.sum.value = newRow.price.value * newRow.count.value;
        return newRow;
      });
      const sumStringValue = array.reduce((sum, row) => (typeof row === 'string' ? +sum : +sum + +row.sum.value), 0);

      this.$store.commit(this.$types.INDEMNITY_LETTER_SET, { ...this.letter, tableRows: array, sumString: sumStringValue });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-control {
  border: none !important;
  font-size: 15px;
  font-weight: 500;
}
.form-control:focus {
  box-shadow: none !important;
  border: none !important;
}
.table th, .table td {
  vertical-align: middle !important;
}
.addRowButton {
  box-shadow: none !important;
}
</style>
